import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.creditsPage.alertTitle, 'Alert'),
  cancel: () => __(translations.creditsPage.cancel, 'Cancel'),
  yesImSure: () => __(translations.creditsPage.yesImSure, "Yes, I'm sure"),
  toggleStatusMessage: () => __(translations.creditsPage.toggleStatusMessage, 'Are you sure you want to change the status of this credit?'),
};
